import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumb from "../Header/SecondHeader";
import trans from "../../utils";
import { Segmented } from "antd";
import Users from "../Users/Users";
import { popupcontext } from "../../context/Popupscontext";
import Permissions from "./Permissions/Permissions";
import { filtrationcontext } from "../../context/Filtercontext";
import Roles from "./Roles/Roles";
import Technicians from "../Facility-Management/Technicians/Technicians";
import Customers from "../Customers/Cutomers";
import usePermission from "../../hooks/usePermission";
import { useSelector } from "react-redux";

export default function RolesPermissions() {
	const [selected, setSelected] = useState("users");
	const { handleShow, setForm } = useContext(popupcontext);
	const { setSearchQuery } = useContext(filtrationcontext);
	const [selectedKey, setSelectedKey] = useState("1");
	const [bulkUpload, setBulkUpload] = useState(false);
	const { create } = usePermission("SETUPUSERROLES");
	const inf = useSelector((state) => state.users.user);
	const options = [
		// {
		// 	label: "overview",
		// 	value: "overview",
		// 	icon: (
		// 		<img
		// 			src={`${process.env.PUBLIC_URL}/assets/New/RolesPermissions/overview.svg`}
		// 			alt="overview"
		// 		/>
		// 	),
		// },
		{
			label: "roles",
			value: "roles",
			icon: (
				<img
					src={`${process.env.PUBLIC_URL}/assets/New/RolesPermissions/roles.svg`}
					alt="roles"
				/>
			),
		},
		...(inf?.administrator
			? [
					{
						label: "permissions",
						value: "permissions",
						icon: (
							<img
								src={`${process.env.PUBLIC_URL}/assets/New/RolesPermissions/permissions.svg`}
								alt="permissions"
							/>
						),
					},
				]
			: []),
		{
			label: "users",
			value: "users",
			icon: (
				<img
					src={`${process.env.PUBLIC_URL}/assets/New/RolesPermissions/user.svg`}
					alt="users"
				/>
			),
		},
		// {
		// 	label: "history",
		// 	value: "history",
		// 	icon: (
		// 		<img
		// 			src={`${process.env.PUBLIC_URL}/assets/New/RolesPermissions/history.svg`}
		// 			alt="history"
		// 		/>
		// 	),
		// },
	];
	const actionType = () => {
		if (selected === "permissions") {
			return "Add new permission";
		} else if (selected === "roles") {
			return "Add new role";
		} else if (selected === "users") {
			if (selectedKey === "1") {
				return "Add new user";
			} else if (selectedKey === "2") {
				return "Add new technician";
			} else if (selectedKey === "3") {
				return "Add new customer";
			}
		}
	};
	useEffect(() => {
		if (selected !== "users") {
			setSelectedKey("1");
		}
	}, [selected]);
	const renderItems = () => {
		if (selected === "users") {
			if (selected === "users") {
				if (selectedKey === "1") {
					return <Users />;
				} else if (selectedKey === "2") {
					return (
						<Technicians
							setBulkUpload={setBulkUpload}
							bulkUpload={bulkUpload}
						/>
					);
				} else if (selectedKey === "3") {
					return <Customers />;
				}
			}
		} else if (selected === "permissions") {
			return <Permissions />;
		} else if (selected === "roles") {
			return <Roles />;
		}
	};
	return (
		<>
			<Helmet>
				<title>Roles & Permissions</title>
				<meta name="description" content="RolesPermissions" />
			</Helmet>
			<BreadCrumb
				add={create ? trans(actionType()) : null}
				onClick={() => handleShow("addForm")}
				setSelectedKey={setSelectedKey}
				selectedKey={selectedKey}
				selected={selected}
				secClick={() => setBulkUpload(true)}
			/>
			<Segmented
				options={options?.map((i) => ({
					label: trans(i.label),
					value: i.value,
					icon: i.icon,
				}))}
				onChange={(value) => {
					setForm(false);
					setSearchQuery("");
					setSelected(value);
				}}
				value={selected}
				block
			/>
			{renderItems()}
		</>
	);
}
